<template lang="">
  <v-container>
    <v-row justify="center">
      <v-col cols="12 mb-6" class="d-flex justify-center">
        <h1>{{ name }} History</h1>
      </v-col>
      <v-col
        cols="8"
        v-for="({ date, message, name: userName, userId }, i) in history"
        :key="i"
      >
        <v-btn
          fab
          dark
          fixed
          top
          left
          color="red"
          @click="removeProjectHistory"
        >
          <v-progress-circular
            v-if="refreshing"
            indeterminate
          ></v-progress-circular>
          <v-hover v-else v-slot="{ hover }">
            <v-icon>{{ hover ? "mdi-delete" : "mdi-delete-outline" }}</v-icon>
          </v-hover>
        </v-btn>
        <v-btn
          fab
          dark
          fixed
          bottom
          right
          color="blue-grey"
          @click="getProjectHistory"
        >
          <v-progress-circular
            v-if="refreshing"
            indeterminate
          ></v-progress-circular>
          <v-icon v-else>mdi-cached</v-icon>
        </v-btn>
        <v-card class="d-flex justify-space-between pa-2" rounded>
          <span class="font-weight-bold" v-if="userName && userName.length > 0">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on" style="color:blue"
                  >To {{ userName }}</span
                >
              </template>
              <span>{{ userId }}</span> </v-tooltip
            >: {{ message }}</span
          >
          <span class="font-weight-bold" v-else>
            <span style="color:blue">To {{ userId }}</span
            >: {{ message }}
          </span>
          <span class="caption">{{ date }}</span>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import prettyMilliseconds from "pretty-ms";
export default {
  data() {
    return {
      history: [],
      refreshing: false,
      name: "",
    };
  },
  methods: {
    getProjectHistory() {
      this.refreshing = true;
      return this.$http
        .get(`/projects/history/${this.$route.params.id}`)
        .then(({ data }) => {
          data.history.forEach(({ date }, i) => {
            if (new Date() - new Date(date) > 60000) {
              data.history[i].date = prettyMilliseconds(
                new Date() - new Date(date),
                { compact: true }
              );
            } else {
              data.history[i].date = "0m";
            }
          });
          this.history = data.history.reverse();
          this.name = data.name;
          this.refreshing = false;
        })
        .catch((err) => {
          console.log("err :>> ", err);
          this.refreshing = false;
        });
    },
    removeProjectHistory() {
      this.refreshing = true;
      return this.$http
        .delete(`/projects/history/${this.$route.params.id}`)
        .then(({ data }) => {
          this.getProjectHistory()
            .then(() => {
              this.$http({
                url: `http://localhost:8081/webhooks/theradia`,
                method: "post",
                data: {
                  projectId: "5fe1073f4a85e701b471bf03",
                  message: {
                    from: {
                      id: 1258089477,
                      first_name: "admin",
                    },
                    text: "aaaaa",
                  },
                  metadata: {
                    clearContext: true,
                  },
                },
              });
              this.refreshing = false;
            })
            .catch((err) => {
              console.log("err :>> ", err);
              this.refreshing = false;
            });
        })
        .catch((err) => {
          console.log("err :>> ", err);
          this.refreshing = false;
        });
    },
  },
  beforeMount() {
    this.intervalid1 = setInterval(
      function() {
        this.getProjectHistory();
      }.bind(this),
      1000
    );
  },
};
</script>
<style lang=""></style>
